import { render } from "./AdminInfoTab.vue?vue&type=template&id=2686d1ea"
import script from "./AdminInfoTab.vue?vue&type=script&lang=js"
export * from "./AdminInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__